import * as api from 'common/service/server-api';
import Jt from 'common/util/jt';
import wxShare from 'common/service/wx-share';
import {inApp, appName, appSlogan, appLogo} from 'common/constant';

const Jt_B = Jt.base;
const Jt_D = Jt.dom;

// 设置分享数据
function setShareData(data) {
    var data = JSON.parse(JSON.stringify(data));
        data.title = data.subject.title;
        data.imgUrl = data.subject.imageUrl;
        data.digest = data.subject.description;
        data.detailUrl = window.location.href;
    const imgs = data.imageUrl ? data.imageUrl.split(',http') : [];
    if(inApp && JSAPI.setShareContent) {
        // 华为端
        const shareData = {
            title: data.title || appName,
            desc: data.description || appSlogan,
            url: data.detailUrl,
            wxthumb: imgs.length ? imgs[0] : appLogo
        };
        JSAPI.setShareContent(JSON.stringify(shareData));
    } else {
        // 普通WAP端
        wxShare.setData({
            title: data.title,
            desc: data.digest,
            imgUrl: imgs.length ? imgs[0] : appLogo
        });
    }
}

const subject = {
    state: {
        // 网络是否连接
        onLine: true,
        // 专题是否存在
        isExist: true,
        // 是否正在加载
        loading: false,
        // 专题详情数据
        normal: {}
    },
    mutations: {
        'subject:reset'(state) {
            state.onLine = true;
            state.isExist = true;
            state.loading = false;
            state.normal = {};
        },
        'subject:update'(state, payload) {
            for(let key in payload) {
                state[key] = payload[key];
            }
        }
    },
    actions: {
        async 'subject:init'({commit, dispatch}, {id}) {
            commit('subject:reset');
            if(!id) {
                commit('subject:update', {isExist: false});
            } else {
                // 获取专题详情数据
                dispatch('subject:query:normal', {id});
            }
        },
        async 'subject:reload'({commit, dispatch}, id) {
            commit('subject:update', {loading: true});
            setTimeout(() => {
                dispatch('subject:query:normal', id);
            }, 3000);
        },
        async 'subject:query:normal'({commit, dispatch, state}, {id}) {
            // if(typeof navigator.onLine !== 'undefined' && !navigator.onLine) {
            //     commit('subject:update', {onLine: false});
            // }
            commit('subject:update', {loading: true, onLine: true});
            let code, data
            api.getSubject({id}, (res) => {
                code = res.code;
                data = res.data;
                const payload = {loading: false, isExist: true};
                if(code === 0) {
                    if(!Jt_B.isEmpty(data)) {
                        payload.normal = data;
                        // 设置页面标题
                        Jt_D.setDocTitle(data.title);
                        // 设置分享数据
                        setShareData(data);
                    } else {
                        payload.isExist = false;
                    }
                } else {
                    payload.isExist = false;
                }
                commit('subject:update', payload);
            });
        }
    },
    getters: {
        'subject:onLine'(state) {
            return state.onLine;
        },
        'subject:isExist'(state) {
            return state.isExist;
        },
        'subject:loading'(state) {
            return state.loading;
        },
        'subject:normal'(state) {
            return state.normal;
        }
    }
};

export default subject;



// WEBPACK FOOTER //
// ./src/common/store/module/subject.js